<div class="zoom-buttons">
    <div>
        <span [ngClass]="{'disabled':  inDisabled}" title="Zoom In" (click)="onIn()" >
            <em><strong>{{inLabel}}</strong></em>
        </span>
        <span [ngClass]="{'disabled': outDisabled }" title="Zoom Out" (click)="onOut()">
            <em><strong>{{outLabel}}</strong></em>
        </span>
    </div>
</div>